export enum VehicleType {
  Corporate = 'Corporate',
  Company = 'Company',
  Personal = 'Personal',
}

export enum VehicleTypeID {
  Corporate = 1,
  Personal = 2,
  Company = 3,
}
